import PropTypes from "prop-types";
import React from "react";
import { graphql } from "gatsby";
import Wrapper from "../Wrapper";
import { Box, Heading } from "rebass/styled-components";
import Forms from "../../Forms";

const Form = ({ data }) => {
  return (
    <Wrapper data={data}>
      <Box px={[2, 2, 5, 0]}>
        <Box color="secondary" textAlign="center">
          <Heading as="h2">{data.title}</Heading>
        </Box>
        <Forms data={data.form.frontmatter} />
      </Box>
    </Wrapper>
  );
};

Form.propTypes = {
  data: PropTypes.shape({
    form: PropTypes.shape({
      frontmatter: PropTypes.any
    }),
    title: PropTypes.any
  })
};
export default Form;

export const query = graphql`
  fragment FormBlock on MarkdownRemarkFrontmatterBlockscollection {
    form {
      frontmatter {
        title
        alignItems
        formId
        intro
        successMessage
        elements {
          imputType
          label
          width
          name
          required
          type
          default
          className
          multiple
          maxFiles
          maxSizeBytes
          options {
            value
            label
          }
          shakey
          vads_amount
          vads_payment_config
          vads_page_action
          vads_currency
          vads_ctx_mode
          vads_site_id
          vads_url_refused
          vads_url_return
          vads_url_success
          vads_url_cancel
          vads_url_error
          vads_url_check
        }
      }
    }
  }
`;
